import { makeStyles } from "@material-ui/core/styles";
import { PostOrderMessageForm } from "components/front/mypage/message/PostOrderMessageForm";
import { MessageThread } from "interfaces/front/business";
import { FrontMessageService, Message } from "lib/service/client/FrontMessageService";
import { useRouter } from "next/router";
import React, { FC, useEffect, useRef, useState } from "react";
import { animateScroll } from "react-scroll";
import { AccountMessageArea, MemberMessageArea } from "./MessageArea";
import { PostContactMessageForm} from "./PostContactMessageForm";

type MessageThreadAreaProps = {
  activate: () => void;
  deactivate: () => void;
  messageThread: MessageThread;
};
export const MessageThreadArea: FC<MessageThreadAreaProps> = (props: MessageThreadAreaProps) => {
  const router = useRouter();
  const [messages, setMessages] = useState<Message[]>([]);
  const addMessage = (message: Message): void => {
    setMessages((messages) => [...messages, message]);
  };
  const listMessages = async (): Promise<void> => {
    const query = { message_thread_id: props.messageThread.id };
    const messageService = new FrontMessageService();
    switch (props.messageThread.topic_type) {
      case "contact":
        await messageService.listContactMessage(query, router, setMessages);
        break;
      case "order":
        await messageService.listOrderMessage(query, router, setMessages);
        break;
    }
  };
  useEffect(() => {
    listMessages();
  }, [props.messageThread.id]);

  const chatAreaBox = useRef<HTMLDivElement>(null);
  const chatArea = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (chatArea?.current && chatAreaBox?.current) {
      animateScroll.scrollTo(chatAreaBox.current.offsetHeight);
    }
  }, [messages]);

  const classes = useStyles();
  return (
    <div className={`mypage_content_message_chat ${classes.root}`}>
      <div className="mypage_content_message_chat_back sp" onClick={props.deactivate}>
        <p className="mypage_content_message_chat_back_text">メッセージ一覧に戻る</p>
      </div>
      <div className="mypage_content_message_chat_area" ref={chatArea}>
        <div className="mypage_content_message_chat_area_box" ref={chatAreaBox}>
          {messages.map((message) => {
            switch (message.source_type) {
              case "from_account":
                return <AccountMessageArea key={message.id} message={message} />;
              case "from_member":
                return <MemberMessageArea key={message.id} message={message} />;
            }
          })}
        </div>
      </div>
      {props.messageThread.topic_type === "contact" && (
        <PostContactMessageForm messageThread={props.messageThread} onSuccess={addMessage} />
      )}
      {props.messageThread.topic_type === "order" && <PostOrderMessageForm messageThread={props.messageThread} onSuccess={addMessage} />}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("md")]: {
      width: "612px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "660px"
    },
    ["@media (min-width:1921px)"]: {
      width: "830px"
    }
  }
}));
